const zh = {
  home: {
    biometric_label: "生物特征身份验证",
    title: "人脸反向搜索，轻松实现",
    description:
      "上传高分辨率肖像，使用先进的神经网络匹配技术与全球数字档案进行交叉比对。",
    drag_drop: "拖放您的图片",
    file_formats: "支持 RAW、JPEG 或 PNG（最大 15MB）",
    select_file: "从系统选择文件",
    initiate_scan: "开始法证扫描",
    upload_hint: "请上传图片以继续",
    uploading: "上传中",
    searching: "扫描中",
    result_title: "结果",
    drop_here: "将图片拖放至此...",
    billion_faces: "与互联网上超过 10 亿张面孔比对",
    login_to_search: "登录以搜索",
    login_required: "请登录或创建账户以使用此应用",
    not_enough_tokens: "令牌不足",
    please_wait: "请等待几分钟",
    leave_confirmation: "有正在进行的任务。您确定要离开吗？",
  },
  sources: {
    section_title: "搜索来源",
    social_media: {
      name: "社交媒体",
      description: "在各大社交网络和公开资料中进行交叉引用。",
    },
    web: {
      name: "网络",
      description: "扫描开放网络中公开可用的面部数据。",
    },
    scammers: {
      name: "诈骗者",
      description: "与已知诈骗者身份和欺诈数据库进行匹配。",
    },
    sexual_offenders: {
      name: "性犯罪者",
      description: "与公开注册的性犯罪者数据库进行交叉引用。",
    },
    videos: {
      name: "视频",
      description: "从公共视频平台提取并匹配面孔。",
    },
    police_photos: {
      name: "警方照片",
      description: "与公开的警方记录数据库进行比较。",
    },
    news_and_blogs: {
      name: "新闻和博客",
      description: "搜索新闻档案、编辑内容和博客。",
    },
  },
  header: {
    scan: "扫描",
    history: "历史",
    pricing: "价格",
    account: "账户",
    logout: "退出",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright: "© 2024 Digital Forensicist. 保留所有权利。精准身份验证。",
    privacy: "隐私政策",
    terms: "服务条款",
    docs: "文档",
    support: "支持",
  },
  common: {
    loading: "加载中...",
    error: "错误",
    cancel: "取消",
    back: "返回",
  },
  errors: {
    upload_failed: "上传失败。请重试。",
    not_enough_tokens: "您没有足够的令牌来执行此搜索。",
  },
  login: {
    disclaimer:
      "您需要一个账户才能使用此应用。我们不发送垃圾邮件，也不共享您的电子邮件。建议使用 Apple 登录以保护隐私。",
  },
  results: {
    input_source: "输入来源",
    match_thumbnail: "匹配缩略图",
    extraction_id: "提取ID",
    scan_analysis: "扫描分析",
    scan_description:
      "生物特征逆向查找已完成。在公共注册表和社交索引中找到%{count}个潜在匹配项。",
    col_identity_map: "身份图谱",
    col_verification_path: "验证路径",
    col_bio_match_score: "生物匹配分数",
    col_action: "操作",
    export_pdf: "导出PDF",
    exporting: "生成中...",
    verified: "已验证",
    details: "详情",
    details_tooltip: "运行精确人脸比对",
    details_loading: "比对中...",
    copied: "已复制！",
    copy_url: "复制URL",
    displaying: "显示%{count}条，共%{total}条",
  },
};

export default zh;
